import StickyNavigation from '../../../shared/scripts/sticky-navigation';

/**
 * Swap a broken external image for the placeholder colour it carries.
 *
 * @param {HTMLImageElement} img The failed image.
 */
const replaceWithPlaceholder = ( img ) => {
	const placeholder = document.createElement( 'span' );
	placeholder.className = 'fv-timeline__placeholder';
	placeholder.setAttribute( 'aria-hidden', 'true' );
	placeholder.dataset.variant = img.dataset.variant || '0';
	img.replaceWith( placeholder );
};

/**
 * External images are hot-linked, so they may be blocked (mixed content) or gone.
 * Fall back to the placeholder both for late failures and for images that had
 * already failed before this script ran.
 */
const guardExternalImages = () => {
	document.querySelectorAll( '.fv-timeline__image--external' ).forEach( ( img ) => {
		if ( img.complete && 0 === img.naturalWidth ) {
			replaceWithPlaceholder( img );
			return;
		}

		img.addEventListener( 'error', () => replaceWithPlaceholder( img ), { once: true } );
	} );
};

/**
 * Open the year a fragment points at.
 *
 * With "collapse older years" on, jumping to a year would otherwise land on a
 * closed `<details>` — a bare header with its items hidden. Browsers only
 * auto-open a `<details>` when the fragment targets something inside it, and the
 * anchor sits on the wrapping section, so open it here.
 *
 * @param {string} hash The target fragment, including its `#`.
 */
const openYear = ( hash ) => {
	if ( ! hash || 1 === hash.length ) {
		return;
	}

	const details = document.getElementById( hash.slice( 1 ) )?.querySelector( '.fv-timeline__year-details' );

	if ( details ) {
		details.open = true;
	}
};

window.addEventListener( 'DOMContentLoaded', () => {
	const nav = document.querySelector( '.fv-timeline__nav' );

	if ( nav ) {
		// Before the sticky navigation is constructed, so the year is already open
		// by the time its own `hashchange` handler measures where to scroll.
		window.addEventListener( 'hashchange', () => openYear( window.location.hash ) );

		// A link to the year already in the hash fires no `hashchange` of its own.
		nav.addEventListener( 'click', ( event ) => openYear( event.target.closest( 'a[href^="#"]' )?.hash ) );

		openYear( window.location.hash );

		new StickyNavigation( nav );
	}

	guardExternalImages();
} );
